<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="800">
      <v-form ref="SetDateTimeForm" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action }} Availability</span>
            <v-spacer></v-spacer>
            <v-btn icon="mdi-close" variant="text" @click="closeD()"> </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Date Until"
                    :model-value="formatDate(date_until)"
                    variant="outlined"
                    density="compact"
                    readonly
                    :rules="[formRules.required]"
                    @click="showDatePicker1 = true"
                  ></v-text-field>

                  <v-dialog v-model="showDatePicker1" max-width="290">
                    <v-date-picker
                      v-model="date_until"
                      @update:model-value="saveDateFrom"
                      :color="$vuetify.theme.themes.light.inputColor"
                    ></v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="Time Until"
                    :model-value="formatTime(time_until)"
                    variant="outlined"
                    density="compact"
                    readonly
                    :rules="[formRules.required]"
                    @click="showTimePicker1 = true"
                  ></v-text-field>

                  <v-dialog v-model="showTimePicker1" max-width="400">
                    <v-card max-width="400">
                      <template v-slot:text>
                        <v-time-picker
                          v-model="time_until"
                          ampm
                          ampm-in-title
                          :color="$vuetify.theme.themes.light.inputColor"
                        ></v-time-picker>
                      </template>

                      <template v-slot:actions>
                        <v-btn
                          class="ms-auto"
                          text="Ok"
                          @click="saveTimeAM_IN"
                        ></v-btn>
                      </template>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              outlined
              @click="closeD()"
              v-if="action != 'View'"
            >
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              v-if="action != 'View'"
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="
                action == 'Add' ? save() : action == 'Update' ? update() : null
              "
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      headers: [
        { title: "Date Until", value: "date_until", align: "start" },
        { title: "Time Until", value: "time_until", align: "center" },
      ],
      setTimeDialog: false,
      isSetGlobal: false,
      dialog: false,
      date_until: null,
      date_to: null,
      schedules: [],
      btnLoading: false,
      deletedFile: null,
      showDatePicker1: false,
      showDatePicker2: false,
      showTimePicker1: false,
      showTimePicker2: false,
      showTimePicker3: false,
      showTimePicker4: false,
      time_until: null,

      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.$refs.SetDateTimeForm.resetValidation();
        if (data.id) {
          this.date_until = data.date_until;
          this.time_until = data.time_until;
        } else {
          this.$refs.SetDateTimeForm.reset();
        }
      },
      deep: true,
    },
  },
  methods: {
    saveDateFrom() {
      if (this.date_until) {
        this.date_until = this.formatDate3(this.date_until);
        this.showDatePicker1 = false;
      }
    },

    saveTimeAM_IN() {
      if (this.time_until) {
        console.log(this.time_until);
        // this.time_until = this.formatDate3(this.time_until);
        this.showTimePicker1 = false;
      }
    },

    async update() {
      let formValid = await this.$refs.SetDateTimeForm.validate();

      if (formValid.valid) {
        this.btnLoading = true;
        let data = {
          date_until: this.date_until,
          time_until: this.time_until,
        };

        this.axiosCall(
          "/skill-assessement/update-sa-valid-until/" + this.data.id,
          "PATCH",
          data,
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    closeD() {
      eventBus.emit("closeSetDateTimeDialog", true);
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
.box {
  width: 200px;
  cursor: pointer;
}
.box:hover {
  background-color: #00a63e;
  color: white;
}
</style>
